let apiUrl;
if (window.location.protocol === "http:") {
  apiUrl = process.env.REACT_APP_BACKEND_URL;
} else {
  apiUrl = process.env.REACT_APP_BACKEND_URL_SSL;
}
// const apiUrl = process.env.REACT_APP_BACKEND_URL_SSL;

const TEMP_MEDIA_ORIGINS = [
  "https://www.ppdqq.com:5703",
  "http://www.ppdqq.com:5703",
];
const TEMP_CDN_ORIGIN = "https://cdn.ppdqq.com";

export const apiDict = {
  base: apiUrl,
  navigate: null,
  article: "/api/v1/article/article",
  userinfo: "/api/v1/user/user/me",
  login: "/api/v1/auth/login",
  signup: "/api/v1/auth/signup",
  logout: "/api/v1/auth/logout",
  refreshToken: "/api/v1/auth/refresh_token",
  comment: "/api/v1/article/comment",
  category: "/api/v1/article/category",
  chartlet: "/api/v1/article/chartlet",
  articleAvatar: "/api/v1/article/avatar",
};

if (process.env.NODE_ENV === "development") {
  apiDict["media"] = "/api/v1/media/"; // gin静态文件路径
} else if (process.env.NODE_ENV === "production") {
  apiDict["media"] = "/media/"; // nginx配置的静态文件路径
}

export function setNavigate(navigate) {
  apiDict.navigate = navigate;
}

export function replaceTempCdnUrl(url) {
  if (!url || typeof url !== "string") {
    return url;
  }
  return TEMP_MEDIA_ORIGINS.reduce(
    (currentUrl, origin) => currentUrl.replaceAll(origin, TEMP_CDN_ORIGIN),
    url
  );
}

export function getMediaUrl(mediaPath) {
  if (!mediaPath) {
    return "";
  }
  return replaceTempCdnUrl(`${apiDict.base}${apiDict.media}${mediaPath}`);
}

export function apiContext(
  url,
  method,
  setDatas,
  setStatusCode,
  data,
  contentType,
  oldArticleDatas,
  setMsgBoxShow,
  setMsgTips,
) {
  let fullUrl;

  // 1. 拼接url
  if (url.substr(0, 4) === "http") {
    fullUrl = url;
  } else {
    fullUrl = apiUrl + url;
  }

  // 2. 获取认证头
  const jwToken = localStorage.getItem("access");

  // 3. 构建请求
  let request;
  // 方法为GET, DELETE
  if (method === "GET" || method === "DELETE") {
    request = fetch(fullUrl, {
      method: method,
      mode: "cors",
      credentials: "include",
      headers: jwToken
        ? {
            Authorization: jwToken,
          }
        : {},
    });
  } else {
    // 方法为POST, PUT, PATCH
    const headers = {};
    if (jwToken) {
      headers["Authorization"] = jwToken;
    }

    const formData = new FormData();
    if (contentType === "form") {
      if (data) {
        for (let key in data) {
          formData.append(key, data[key]);
        }
      }
    } else {
      headers["Content-Type"] = "application/json";
    }

    request = fetch(fullUrl, {
      method: method,
      mode: "cors",
      credentials: "include",
      body: contentType === "form" ? formData : JSON.stringify(data),
      headers: headers,
    });
  }

  function readResponseBody(resp) {
    const ct = resp.headers && resp.headers.get
      ? resp.headers.get("content-type") || ""
      : "";
    if (ct.includes("application/json")) {
      return resp.json().catch(() => null);
    }
    return resp
      .text()
      .then((t) => {
        if (!t) {
          return null;
        }
        try {
          return JSON.parse(t);
        } catch (e) {
          return t;
        }
      })
      .catch(() => null);
  }

  request
    .then((resp) => {
      if (resp.status === 401) {
        // access token过期, 刷新token
        fetch(apiDict.base + apiDict.refreshToken, {
          method: "GET",
          mode: "cors",
          credentials: "include",
        })
          .then((resp2) => {
            if (resp2.status === 200) {
              return resp2.json();
            } else {
              if (setMsgBoxShow !== undefined && setMsgTips !== undefined) {
                setMsgBoxShow(true);
                setMsgTips({ status: "warning", msg: "登录失效" });
              }
              setTimeout(() => {
                apiDict.navigate && apiDict.navigate("/user/login", {state: oldArticleDatas});
              }, 1000);
              return null;
            }
          })
          .then((resp3) => {
            if (resp3) {
              localStorage.setItem("access", resp3.access);

              // 刷新token成功, 重新请求
              apiContext(
                url,
                method,
                setDatas,
                setStatusCode,
                data,
                contentType,
                oldArticleDatas,
                setMsgBoxShow,
                setMsgTips,
              );
            }
          });

        return null;
      } else if (resp.status !== 200 && resp.status !== 201) {
        console.error("something wrong!");
      }
      if (setStatusCode !== undefined && setStatusCode !== "") {
        setStatusCode(resp.status);
      }
      return readResponseBody(resp).then((body) => ({
        status: resp.status,
        body,
      }));
    })
    .then((data) => {
      if (data && setDatas !== undefined && setDatas !== "") {
        if (data.status === 200 || data.status === 201) {
          setDatas(data.body);
        } else {
          setDatas("null");
        }
      }
    });
}
